// status.schema.json source (06k C11) — payload của `avatar autopilot status
// --json` (`{command, payload}`). Lõi có kiểu = các field vòng lái từ chat đọc
// (supervisor/last_run/gate/queue) + nhãn mission; phần còn lại (bảng vận hành,
// cost, limits…) đi qua `looseObject` để thêm field không vỡ phía đọc cũ.
import { z } from "zod";

/** `runtime/last-run.json` (C3) — kết quả máy của lần `run --json`/`--detach` gần nhất. */
export const LastRunFileSchema = z
  .object({
    schema_version: z.literal(1),
    run_id: z.string().min(1),
    state: z.enum(["running", "exited"]),
    pid: z.number().int().positive(),
    started_at: z.string().min(1),
    detached: z.boolean(),
    log_path: z.string().optional(),
    /** Review L6: mốc khởi động tiến trình (như lock) — pid tái dùng ⇒ không còn "running". */
    process_started_at: z.string().optional(),
    /** Object `result` của `run --json` (C4) — vắng khi run lỗi trước khi có kết quả. */
    result: z.record(z.string(), z.unknown()).optional(),
  })
  .strict();

export const StatusPayloadSchema = z.looseObject({
  mission_id: z.string().optional(),
  status: z.string().optional(),
  store_status: z.enum(["READY", "RECOVERING"]),
  supervisor_alive: z.boolean(),
  supervisor_pid: z.number().int().positive().optional(),
  machine_lock_mission_id: z.string().optional(),
  last_run: LastRunFileSchema.optional(),
  /** = `last_run.result.resume_at`, chỉ khi còn ở tương lai. */
  resume_at: z.string().optional(),
  gate_approvals: z.array(
    z.object({
      gate: z.string(),
      request_id: z.string(),
      source: z.enum(["human", "chat_delegated"]),
      by: z.string(),
    }),
  ),
  queued_directives: z.array(
    z.object({ directive_id: z.string(), kind: z.string(), source: z.string() }),
  ),
  /** Chỉ có khi gọi `--wait <N>`: true ⇔ hết N giây mà engine không đổi trạng thái. */
  wait_timed_out: z.boolean().optional(),
});

export type StatusPayloadJson = z.infer<typeof StatusPayloadSchema>;
